









































































import mixins from 'vue-typed-mixins';
import vuelidateMixin from "@/mixins/vuelidateMixin";
import { required  , maxLength , requiredIf } from 'vuelidate/lib/validators';
import {ExtensionViewModel} from "../../models/ExtensionViewModel";
import {ExtensionUpdateViewModel} from "@/models/ExtensionUpdateViewModel";
import BoxContainer from "@/components/BoxContainer.vue";
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";

export default mixins( vuelidateMixin ).extend( {
  name: "ExtensionApprovalReadyForReview",
  components: {
    BoxContainer
  },
  props: {
    extension: {
      type: Object as () => ExtensionViewModel
    }
  },
  data(): {
    extensionUpdateViewModel: ExtensionUpdateViewModel
    originalWorkArea: string
    workAreaChanged: boolean
    workAreaList: any[]
    facilityList: any[]
  }{
    return {
      extensionUpdateViewModel: { } as ExtensionUpdateViewModel,
      originalWorkArea: "",
      workAreaChanged: false,
      workAreaList: [],
      facilityList: []
    }
  },
  validations: {
    extensionUpdateViewModel: {
      drawingNumber: {
        required
      },
      trunkToTributary: {
        required
      },
      reasonForWorkAreaChange: {
        maxLength: maxLength(2000),
        requiredIf: requiredIf( function() {
          //@ts-ignore
          return this.workAreaChanged;
        })
      }
    }
  },
  computed: {
    workAreaListSelect(): any[] {

      const workAreaList = [];
      workAreaList.push( { "header" : "Sewerage Areas" } );
      for ( let i = 0; i < this.workAreaList.length; i++ ) {
        if ( this.workAreaList[i].category === 'SA') {
          workAreaList.push( this.workAreaList[i]);
        }
      }
      workAreaList.push( { "header" : "Drainage Areas" } );
      for ( let x = 0; x < this.workAreaList.length; x++ ) {
        if ( this.workAreaList[x].category === 'DA') {
          workAreaList.push( this.workAreaList[x] );
        }
      }
      return workAreaList;
    },
  } ,
  methods: {
    async getWorkAreaList()  {

      const result = await this.axios.get('/Lookups/GetWorkAreas');
      this.workAreaList = result.data;

    },
    async getFacilityList() {
      const results = await this.axios.get('/Lookups/GetFacilities');
      this.facilityList = results.data;
    },
    async handleSubmit() {

      const valid = this.isValidWithNotification(this.$v.extensionUpdateViewModel);

      if ( valid ) {

        try {

          this.extensionUpdateViewModel.extensionId = this.extension.extensionId;

          let tempWA = this.workAreaList.find((w: { abbreviation: string; }) => w.abbreviation === this.extensionUpdateViewModel.workAreaAbbreviation);
          this.extensionUpdateViewModel.workArea = tempWA.displayValue;
          this.extensionUpdateViewModel.workAreaType = tempWA.category;

          let result = await this.axios.post(
              '/Extensions/UpdateExtensionUnderReview',
              this.extensionUpdateViewModel,
              {headers: {"Content-Type": "application/json"}}
          );
          const data = result.data as unknown as ReturnDataViewModel;
          console.log(result);
          console.log(data);

          if ( result.status === 200 ) {
            await this.$router.push({name: "extensions-detail", params: {id: this.extension.extensionId.toString()}});
          }

        }
        catch (err) {
          if ( err.response.status === 400 || err.response.status === 403 || err.response.status === 404 || err.response.status === 409 ) {
            console.log( err.response.data.message )
          }
        }
        finally {
          // do something
        }
      }

    }
  },
  mounted() {
    this.getWorkAreaList();
    this.getFacilityList();
  },
  created() {
    this.originalWorkArea = this.extension.workAreaAbbreviation;
    this.extensionUpdateViewModel.workAreaAbbreviation = this.extension.workAreaAbbreviation;
  },

} )
